import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const checkAdminPrivileges = () => {
    try {
      const targetUser = localStorage.getItem('modische_user');
      
      if (!targetUser || targetUser === 'null' || targetUser === 'undefined' || targetUser === '{}') {
        return false;
      }

      const parsed = JSON.parse(targetUser);
      if (parsed && typeof parsed === 'object' && (parsed.isAdmin === true || parsed.role === 'admin')) {
        return true;
      }
      
      return false;
    } catch (e) {
      console.error("Critical footer shield crash prevented:", e);
      return false; 
    }
  };

  const isAdminUser = checkAdminPrivileges();
  return (
    <footer className="bg-[#2C1E12] text-[#F5F5DC] pt-16 pb-8 px-6 sm:px-12 border-t border-[#E5D3B3]/10 font-sans relative">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 text-left">
        
        {/* COLUMN 1: BRAND LOGO & MOTTO */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img 
              src="/logo_final.jpg" 
              alt="Modische Kledings" 
              className="w-10 h-10 object-contain rounded-full shadow-inner border border-[#E5D3B3]/20"
            />
            <h3 className="text-lg font-serif font-bold uppercase tracking-[0.2em] text-[#FAF9F6] m-0">
              Modische Kledings
            </h3>
          </div>
          <p className="text-xs text-[#F5F5DC]/60 font-serif leading-relaxed max-w-xs">
            Elevated minimalism for the modern wardrobe. Verified premium material quality, slow-fashion ethics, and clean design silhouettes.
          </p>
          {/* INSTAGRAM SOCIAL ICON ROUTE */}
          <div className="pt-2">
            <a 
              href="https://www.instagram.com/modische_kledings?igsh=b3BqejNicTlxM2Zn" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-[10px] uppercase tracking-widest font-bold text-[#FAF9F6] border-b border-[#FAF9F6]/40 pb-0.5 hover:text-[#E5D3B3] hover:border-[#E5D3B3] transition no-underline"
            >
              Instagram ↗
            </a>
          </div>
        </div>

        {/* COLUMN 2: CUSTOMER CARE POLICY LINKS */}
        <div className="space-y-3">
          <h4 className="text-[10px] font-mono font-black uppercase tracking-[0.2em] text-[#E5D3B3]">
            Customer Care
          </h4>
          <ul className="space-y-2 text-xs font-serif uppercase tracking-wider opacity-70 list-none p-0 m-0">
            <li><Link to="/shipping-policy" className="hover:opacity-100 transition text-[#F5F5DC] no-underline">Shipping Logistics</Link></li>
            <li><Link to="/returns-policy" className="hover:opacity-100 transition text-[#F5F5DC] no-underline">Returns & Exchanges</Link></li>
            <li><Link to="/contact" className="hover:opacity-100 transition text-[#F5F5DC] no-underline">Contact Us</Link></li>
          </ul>
        </div>

        {/* COLUMN 3: LEGAL & COMPLIANCE PAGES FOR RAZORPAY */}
        <div className="space-y-3">
          <h4 className="text-[10px] font-mono font-black uppercase tracking-[0.2em] text-[#E5D3B3]">
            Legal & Compliance
          </h4>
          <ul className="space-y-2 text-xs font-serif uppercase tracking-wider opacity-70 list-none p-0 m-0">
            <li><Link to="/terms-and-conditions" className="hover:opacity-100 transition text-[#F5F5DC] no-underline">Terms & Conditions</Link></li>
            <li><Link to="/privacy-policy" className="hover:opacity-100 transition text-[#F5F5DC] no-underline">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* COLUMN 4: NEWSLETTER INSIGHTS */}
        <div className="space-y-4">
          <h4 className="text-[10px] font-mono font-black uppercase tracking-[0.2em] text-[#E5D3B3]">
            Newsletter
          </h4>
          <div className="flex border-b border-[#FAF9F6]/30 pb-2 max-w-xs">
            <input 
              type="email" 
              placeholder="YOUR EMAIL ADDRESS" 
              className="bg-transparent border-none text-xs tracking-wide text-[#FAF9F6] focus:outline-none placeholder:text-[#F5F5DC]/30 flex-1 uppercase font-mono"
            />
            <button className="bg-transparent border-none text-[10px] font-mono font-black uppercase tracking-widest text-[#FAF9F6] hover:text-[#E5D3B3] transition cursor-pointer">
              Join
            </button>
          </div>
        </div>

      </div>

      {/* FOOTER ACCENT BASE */}
      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-[#FAF9F6]/5 flex flex-col sm:flex-row justify-between items-center text-[9px] font-mono uppercase tracking-widest text-[#F5F5DC]/40 gap-4">
        <div>© {new Date().getFullYear()} Modische Kledings</div>
        <div>All Rights Reserved</div>
      </div>

      {isAdminUser && (
        <button 
          onClick={() => navigate('/admin')} 
          className="absolute bottom-4 right-4 bg-red-950 text-[#F5F5DC] text-[8px] uppercase tracking-widest font-black px-3 py-2 rounded-xs opacity-60 hover:opacity-100 transition border-none cursor-pointer shadow-md"
        >
          Open Admin Form
        </button>
      )}
    </footer>
  );
};

export default Footer;